import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { nonSpecificPerformerName, Performer } from 'globals/store/performers.data';
import { SessionItemInfo, ItemStatus, ShareableItemTypes, StandItemInfo, ShareableItemType } from 'globals/store/share.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { ShareCodeComponent } from 'src/app/modules/share/share-code.component';
import { TitleToggleComponent } from '../wrappers/title-toggle-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'staging-request',
    template: `
<title-toggle-wrapper
  [title]="entity?.name || 'Receive ' + type + ' requests from '+nonSpecificPerformerName"
  [hideBottom]="!stagingRequestInfo?.status || stagingRequestInfo?.status === 'Off'"
  [disabled]="readOnly"
  [toggleOn]="stagingRequestInfo && stagingRequestInfo.status !== 'Off'"
  (toggle)="toggle($event)"
  >
  <div class="share-hint">
    YOUR SHAREABLE WEBFORM:
  </div>

  <share-code 
    *ngIf="stagingRequestInfo" 
    [shareType]="shareType"
    [shareCode]="stagingRequestInfo.id" 
    [hideTitle]="true"
    [disabled]="!['Active', 'Submitted'].includes(stagingRequestInfo.status)"
    [hideJson]="true"
    [emailGenerator]="emailGenerator"
    [selectedStatus]="stagingRequestInfo.status"
    (changeStatus)="changeStatus.emit($event)">
  </share-code>

</title-toggle-wrapper>
`,
    styles: [`
  .grey-hint { margin-top: 10px; }
  .share-hint { margin-bottom: 10px; }
  performer-card { display: block; margin-top: 10px; }
`],
    standalone: true,
    imports: [ShareCodeComponent, CommonModule, TitleToggleComponent],
})
export class PerformerStagingRequestComponent {
  @Input() entity: Performer | Exhibitor
  @Input() type: 'staging' | 'exhibitor stand' = 'exhibitor stand'
  @Input() stagingRequestInfo: SessionItemInfo | StandItemInfo
  @Output() changeStatus:EventEmitter<ItemStatus> = new EventEmitter();
  nonSpecificPerformerName = nonSpecificPerformerName
  @Input() readOnly: boolean = false // this is new so false by default
  @Input() shareType: ShareableItemType = 'stagingRequest'
  @Input() emailGenerator: (code: string) => string

  toggle(toggled: boolean) {
    if (toggled) {
      this.changeStatus.emit('Active')
    } else {
      this.changeStatus.emit('Off')
    }
  }
  
}






